<script>
import BreadcrumbNav from "@/components/BreadcrumbNav";
import ContractForm from "@/components/forms/ContractForm";

export default {
    components: {
        BreadcrumbNav,
        ContractForm
    },
    created() {
        const workspaceId = this.$route.params.workspaceId;
        this.workspace = this.$store.getters["workspaces/getWorkspace"](workspaceId);

        this.breadcrumbItems = [
            {
                name: this.Utils.capitalize(this.$t("main.contracts")),
                route: {
                    name: "contracts.index",
                    params: {
                        workspaceId: this.workspace.id
                    }
                }
            },
            {
                active: true,
                name: this.Utils.capitalize(this.$t("main.create_a_contract"))
            }
        ];
    }
};
</script>

<template>
    <div class="container container-small my-5">
        <BreadcrumbNav :items="breadcrumbItems" />
        <div class="card">
            <div class="card-header">{{ Utils.capitalize($t("main.create_a_contract")) }}</div>
            <div class="card-body">
                <ContractForm />
            </div>
        </div>
    </div>
</template>
